export default __webpack_public_path__ + "static/media/frame.faecf78b.svg";